<template>
  <div>
    <div v-if="seznamPodRacunov.length > 0 && !loadingSeznamRacunov">
      <div class="izgled-telefon" v-if="vsotaZapadlih !== 0">
        <InfoKomponentaRacuni/>
      </div>
      <div style="clear: both"/>
      <div class="postavitev-vsebine">
        <p class="navadno-besedilo">
          V seznamu so prikazni izdani računi z relevantnimi datumi, zneski ter morebitne opombe plačil.
          <br/> Vse račune si lahko tudi prenesete na svoj računalnik v .pdf formatu.
        </p>
      </div>
    </div>
    <div v-if="seznamPodRacunov.length > 0 && vsotaZapadlih > 0" style="padding-top: 20px">
      Zapadle obveznosti
      <span :style="'color: ' + (vsotaZapadlih > 0 ? 'orangered' : 'forestgreen')">
        {{ vsotaZapadlih }} EUR
      </span>
    </div>
    <div v-if="noviSeznamObrokov.length > 0">
      <div class="naprave postavitev-box">
        <div>
          <div>
            <el-table
              :data="seznamPodObrokov"
              :default-sort="{prop: 'date', order: 'descending'}"
              :current-page='2' :page-size='1'
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.acKeyView"
              @expand-change="IzbiraVrsticeZaPrikazPodatkov">
              <el-table-column label="Številka računa">
                <div class="td-name" slot-scope="scope">
                  <a href="javascript:void(0)"
                     @click="HtmlPrikaz(scope.row.acKeyView, scope.row.leto, returnHTML = true)"
                     class="primarna-barva">
                    {{ scope.row.acKeyView }}
                  </a>
                </div>
              </el-table-column>
              <el-table-column
                  label="Naziv naprave"
                  :min-width="velikstNazivaNaprave">
                <template slot-scope="scope">
                  <span :style="prikazTabele !== '1' ?  'text-wrap: nowrap;' : ''">
                    {{ scope.row.naziv }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Št. obrokov" v-if="prikazTabele === '1'">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.steviloPlacanih }}
                  </span> /
                  {{ scope.row.stVsehObrokov }}
                </template>
              </el-table-column>
              <el-table-column label="Prenos" min-width="70"  align="center">
                <template slot-scope="scope">
                  <div>
                    <div style="height: 100%;" v-show="scope.row.acKeyView === prenosPdfRacun">
                      Prenos v teku
                      <i class="fa fa-refresh fa-spin" style="font-size:15px">
                      </i>
                    </div>
                    <a style="display: none;" href=""/>
                    <a href="javascript:void(0)" v-show="scope.row.acKeyView !== prenosPdfRacun"
                       @click="PdfPrenos(scope.row.acKeyView, scope.row.leto)" class="primarna-barva dwnldLnk"
                       style="font-weight: normal">
                      <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
                    </a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div>
                    <el-table
                      v-if="prikazTabele === '1'"
                      :data="scope.row.obroki"
                      :default-sort="{prop: 'date', order: 'ascending', prop: 'placano_izpis', order: 'ascending'}"
                      :current-page='2' :page-size='1' width="100%"
                      style="text-align: center; padding-top: 20px; padding-bottom: 20px">
                      <el-table-column label="Št.obroka">
                        <template slot-scope="scope">
                          {{ scope.row.zapStObroka }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Znesek obroka">
                        <template slot-scope="scope">
                          <span v-if="scope.row.znesekObroka !== null">
                            <span>
                              {{ scope.row.znesekObroka + ' €' }}
                            </span>
                          </span>
                          <span v-else>
                            Ni podatka
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Znesek plačila">
                        <template slot-scope="scope">
                          <span v-if="scope.row.znesekPlacila !== null">
                            <span>
                              {{ scope.row.znesekPlacila + ' €' }}
                            </span>
                          </span>
                          <span v-else>
                            Ni podatka
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Datum plačila">
                        <template slot-scope="scope">
                          <span v-if="scope.row.datumPlacila !== null">
                            {{ scope.row.datumPlacila }}
                          </span>
                          <span v-else>
                            Ni podatka
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Rok plačila">
                        <template slot-scope="scope">
                          <span v-if="scope.row.rokPlacila !== null">
                            {{ scope.row.rokPlacila }}
                          </span>
                          <span v-else>
                            Ni podatka
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table
                        v-else
                        :data="scope.row.obroki"
                        show-header="false"
                        :default-sort="{prop: 'date', order: 'ascending', prop: 'placano_izpis', order: 'ascending'}"
                        :current-page='2' :page-size='1' width="100%"
                        style="text-align: center">
                      <el-table-column>
                        <template slot-scope="scope">
                          <el-form label-width="150px" :label-position="formaOrientacija">
                            <el-form-item label="Številka obroka: ">
                              {{ scope.row.zapStObroka }}
                            </el-form-item>
                            <el-form-item label="Znesek obroka">
                              <span v-if="scope.row.znesekObroka !== null">
                                {{ scope.row.znesekObroka + ' €' }}
                              </span>
                            </el-form-item>
                            <el-form-item label="Znesek plačila:">
                              <span v-if="scope.row.znesekPlacila !== null">
                                {{ scope.row.znesekPlacila + ' €' }}
                              </span>
                            </el-form-item>
                            <el-form-item label="Datum plačila:">
                              {{ scope.row.datumPlacila }}
                            </el-form-item>
                            <el-form-item label="Rok plačila:">
                              {{ scope.row.rokPlacila }}
                            </el-form-item>
                            </el-form>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <br style="clear: both"/>
          <div class="text-center">
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStran"
              :current-page="trenutnoIzbranaStran"
              :page-size="8"
              layout="prev, pager, next"
              :total="dolzinaSeznamaRacunov"
              small>
            </el-pagination>
          </div>
        </div>
      </div>
      <div style="clear: both" />
      <div class="odmik-30">
        <hr class="hr-stil"/>
      </div>
      <div class="odmik-30">
        <LegendaIzdaniRacuni/>
      </div>
    </div>
    <div v-if="noviSeznamObrokov.length === 0" v-loading="loadingSeznamRacunov">
      <div class="obvestilo-prazen-seznam">
        <p>
          Nimate izdanih računov za naprave.
        </p>
      </div>
    </div>
    <div>
      <div style="clear: both" />
      <div class="zgornji-odmik-pomoc">
        <div id="bottom">
          <div class="postavitev-besedila-pomoc">
            <p class="open-sans-13pt no-bold">
              <span class="desni-pomik-texta-pomoc">
                Imate vprašanje glede podatkov na računu?
              </span>
              <br />
              <a class="primarna-barva" :href="stranRazlagaRacunaUrl" target="_blank">
                Poglejte si primer in razlago.
              </a>
            </p>
          </div>
          <div class="desna-postavitev-ikone-pomoc">
            <i class="fa fa-question-circle"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from 'vue'
import LegendaIzdaniRacuni from './../../../Views/MojT2/Racuni/LegendaIzdaniRacuni.vue'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {DatePicker, Button, Select, Option, Table, TableColumn, Pagination} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import InfoKomponentaRacuni from "./InfoKomponentaRacuni";
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import { jsPDF } from 'jspdf'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'

Vue.use(Pagination)
export default {
  name: 'IzdaniRacuniZaNaprave',
  mixins: [SirinaOkna, StringConverter, PrikazVsebine, FormatDatuma],
  data() {
    return {
      title: 'Pregled izdanih računov',
      clientAgent: null,
      loadingSeznamRacunov: true,
      seznamPodRacunov: [],
      mejnaSirinaTabela: 1407,
      dolzinaSeznamaRacunov: null,
      prikazTabele: '1',
      expandRowKeys: [],
      trenutnoIzbranaStran: 1,
      stranRazlagaRacunaUrl: '',
      formaOrientacija: 'left',
      mejnaSirina: 350,
      prenosPdfRacun: 0,
      vsotaZapadlih: 0,
      prikazObrokovA: [],
      velikstNazivaNaprave: '80',
      noviSeznamObrokov: [],
      seznamPodObrokov: []
    }
  },
  components: {
    InfoKomponentaRacuni,
    'LegendaIzdaniRacuni': LegendaIzdaniRacuni,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  mounted() {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.stranRazlagaRacunaUrl = povezave.BASE_URL_RAZLAGA_RACUNA
  },
  props: {
    izbranSap: '',
    prikazObrokov: {
      type: Array,
      value: []
    }
  },
  watch: {
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    },
    prikazObrokov (val) {
      if (val.length > 0) {
        this.SeznamObrokovZaPrikaz(val)
      } else {
        this.noviSeznamObrokov = []
        this.loadingSeznamRacunov = false
      }
    },
  },
  methods: {
    SeznamObrokovZaPrikaz(val) {
      this.seznamPodObrokov = []
      this.noviSeznamObrokov = []
      this.noviSeznamObrokov = val
      let tmpArray = []
      this.dolzinaSeznamaRacunov = this.noviSeznamObrokov.length
      const chunk = 8
      for (let i = 0; i < this.dolzinaSeznamaRacunov; i += chunk) {
        tmpArray.push(this.noviSeznamObrokov.slice(i, i + chunk))
      }
      this.noviSeznamObrokov = tmpArray
      this.PrikaziStran(this.trenutnoIzbranaStran)
    },
    PrikaziStran(stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.noviSeznamObrokov[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamPodObrokov = this.noviSeznamObrokov[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamPodObrokov = this.noviSeznamObrokov
      }
      this.loadingSeznamRacunov = false
    },
    IzbiraVrsticeZaPrikazPodatkov(row) {
      const id = row.acKeyView
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    PdfPrenos(idRacuna, leto) {
      this.prenosPdfRacun = idRacuna
      let param = ['sap=' + this.izbranSap]
      param.push('dokument=' + idRacuna)
      param.push('leto=' + leto)
      param.push('format=pdf')
      this.clientAgent.postWsRequest(
        this,
        'stranka/racun/prikazRacuna',
        param,
        null,
        'SetPrenosPdf',
        'ErrPrenosPdf')
    },
    SetPrenosPdf(podatki) {
      let vsebinaPdf = 'data:application/pdf;base64,' + podatki.data.racun
      const downloadLink = document.createElement('a')
      const fileName = 'Račun:' + podatki.data.datoteka + '.' + podatki.data.koncnica
      downloadLink.href = vsebinaPdf
      downloadLink.download = fileName
      downloadLink.click()
      this.prenosPdfRacun = 0
    },
    ErrPrenosPdf(podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.prenosPdfRacun = 0
    },
    HtmlPrikaz(idRacuna, leto, returnHTML = false) {
      let popupWindow = null
      if (returnHTML !== false) {
        popupWindow = window.open('',
          'popUpWindow',
          'height=850,' +
          'width=900,' +
          'left=10,top=10,' +
          'resizable=yes,' +
          'scrollbars=yes,' +
          'toolbar=yes,' +
          'menubar=no,' +
          'location=no,' +
          'directories=no,' +
          'status=yes')
        popupWindow.document.body.innerHTML = '' +
          '<html>' +
          '<body>' +
          'Nalaganje. Prosimo počakajte...' +
          '</body>' +
          '</html>'
      }
      let param = ['sap=' + this.izbranSap]
      param.push('dokument=' + idRacuna)
      param.push('leto=' + leto)
      this.clientAgent.postWsRequest(
        this,
        '/stranka/racun/prikazRacuna',
        param,
        popupWindow,
        'SetPredogledRacuna',
        'ErrPredogledRacuna')
    },
    SetPredogledRacuna(podatki, popupWindow) {
      let racunData = atob(podatki.data.racun)
      let blob = this.base64ToBlob(racunData, 'application/pdf')
      let url = URL.createObjectURL(blob)
      popupWindow.document.write('<iframe width="100%" height="100%" src="' + url + '"></iframe>')
    },
    ErrPredogledRacuna(podatki, popupWindow) {
      popupWindow.document.body.innerHTML = 'Ni mogoče prikazati računa.'
    },
    base64ToBlob (binStr, type = 'application/octet-stream') {
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt( i )
      }
      return new Blob( [ arr ], { type: type } )
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/Racuni/IzdaniRacuni.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni/IzdaniRacuniZaNaprave.vue